import React from "react";
import { Tooltip } from "@pd/pd-ui-kit";

export const filterOptionByLabel = (
  input: string,
  option?: { label?: React.ReactNode },
) =>
  String(option?.label ?? "")
    .toLowerCase()
    .includes(input.toLowerCase());

export const renderMaxTagPlaceholder = (
  omittedValues: Array<{ label?: React.ReactNode; value?: unknown }>,
) => {
  const labels = omittedValues
    .map((item) => item?.label ?? item?.value ?? "")
    .join(", ");
  return (
    <Tooltip
      styles={{ root: { pointerEvents: "none" } }}
      title={labels}
      variant="secondary2"
      arrow={true}
    >
      <span>{`ещё ${omittedValues.length}`}</span>
    </Tooltip>
  );
};
